/**
 * NOTE:
 *
 * This file is automatically generated by i18n-tools.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
// Norwegian Bokmål
export default {
    'fabric.atlassianSwitcher.switchTo': 'Bytt til',
    'fabric.atlassianSwitcher.switchToTooltip': 'Bytt til…',
    'fabric.atlassianSwitcher.recent': 'Nylige',
    'fabric.atlassianSwitcher.more': 'Mer',
    'fabric.atlassianSwitcher.try': 'Prøv',
    'fabric.atlassianSwitcher.manageList': 'Administrer liste',
    'fabric.atlassianSwitcher.jiraProject': 'Jira-prosjekt',
    'fabric.atlassianSwitcher.confluenceSpace': 'Confluence-område',
    'fabric.atlassianSwitcher.people': 'Personer',
    'fabric.atlassianSwitcher.administration': 'Administrasjon',
    'fabric.atlassianSwitcher.discoverMore': 'Få mer informasjon',
    'fabric.atlassianSwitcher.errorHeading': 'Det oppsto en feil',
    'fabric.atlassianSwitcher.errorText': 'Vi registrerer disse feilene, men ta gjerne kontakt hvis det ikke hjelper å oppdatere',
    'fabric.atlassianSwitcher.errorImageAltText': 'En robot som har brutt sammen, og en rekke personer som er opptatt med å fikse den.',
    'fabric.atlassianSwitcher.expand': 'Utvid',
};
//# sourceMappingURL=nb.js.map